import SyIcons from "./sy-icons";

export default SyIcons